export default "__VITE_ASSET__PnN77aiw__"